var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-button',{attrs:{"color":"green","size":"normal","type":"secondary","disabled":_setup.props.disabled,"loading":_setup.state.isConverting,"icon":"attach_money"},on:{"click":_setup.convert}},[_vm._v("Create "+_vm._s(_setup.convertingTo))])
}
var staticRenderFns = []

export { render, staticRenderFns }